import { useEffect, useState } from 'preact/hooks';

const STORAGE_KEY = 'clock:format';

/**
 * Live clock widget. Ticks every second, aligned to whole-second boundaries.
 * Toggle button (top-right) flips between 24-hour and 12-hour formats;
 * the preference persists in localStorage.
 */
export const Clock = ({ timezone = 'Australia/Melbourne', label = 'Melbourne' }) => {
  const [now, setNow] = useState(() => new Date());
  const [is24h, setIs24h] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.localStorage.getItem(STORAGE_KEY) !== '12';
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, is24h ? '24' : '12');
  }, [is24h]);

  useEffect(() => {
    let intervalId;
    const drift = 1000 - (Date.now() % 1000);
    const timeoutId = setTimeout(() => {
      setNow(new Date());
      intervalId = setInterval(() => setNow(new Date()), 1000);
    }, drift);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  const time = now.toLocaleTimeString('en-AU', {
    timeZone: timezone,
    hour12: !is24h,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <div class="surface-card relative min-w-[180px] px-5 py-3">
      <button
        type="button"
        onClick={() => setIs24h((v) => !v)}
        title="Toggle 12 / 24 hour"
        aria-label={`Switch to ${is24h ? '12 hour' : '24 hour'} time`}
        class="absolute right-3 top-3 rounded border border-border-strong px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-label text-text-tertiary transition hover:border-brand hover:text-brand focus:outline-none focus-visible:border-brand focus-visible:text-brand"
      >
        {is24h ? '24h' : '12h'}
      </button>
      <p class="label mb-1">Now</p>
      <p class="m-0 font-serif text-[28px] font-medium leading-none tracking-tighter text-text-primary">
        {time}
      </p>
      <p class="m-0 mt-1.5 text-[12px] font-medium text-text-tertiary">{label}</p>
    </div>
  );
};
